import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31638f32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }

import { Form, Field, CellGroup } from 'vant';


import { useRouter } from 'vue-router'
import { apiGetToken } from '@/apis/public/oauth'
import { useStore } from '@/utils/db'
import wx from 'weixin-js-sdk'
import { ref, watch } from 'vue'
import { getQueryString } from '@/utils/common'
import { wxAuth } from '@/apis/weixin'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()


console.log('wx==>', wx)
// 网页授权
// 1. 判断是否已经拥有openid，有则跳过授权步骤，无则进入授权流程
// 2. ssid为后端缓存的key，用于获取用户的openid
const openId = ref('')
const weixinAuth = async () => {
  // 获取url中ssid
  const ssid = getQueryString('ssid')
  const q: any = {}
  if (ssid) q.ssid = ssid

  // 请求授权接口
  const res = await wxAuth({ ssid: ssid })
  // console.log('===>res', res)
  if (res.code == 302) {
    location.href = res.data.redirect_url
  } else {
    store.setUserInfo(res.data)
    console.log('显示本地保存-userinfo', store.getUserInfo)
    getToken()
  }
}



const getToken = async () => {
  // let userinfo = store.getUserInfo
  let q = {
    openid: store.getUserInfo?.wx_user.openid
  }
  const res = await apiGetToken(q)
  if (res.code === 200) {
    store.setToken(res.data)
    console.log('show-token->', store.getToken)   
    router.push({ path: '/home', replace: true })
  }
  //  .then(res => {
  //     store.setToken(res.data)
  //     console.log('show-token->', store.getToken)
  //   })
}
//
// getToken()
weixinAuth()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " 正在登录 "))
}
}

})